import { map, take, filter } from 'rxjs';

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { AuthService } from '@/app/core/services/auth/auth.service';

export const AdminGuard: CanMatchFn = () => {
  const authService = inject(AuthService);

  return authService.userLoaded$.pipe(
    filter((loaded) => loaded),
    take(1),
    map(() => {
      return authService.user()!.registered_as_admin;
    }),
  );
};
